export const InfoIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="elements">
      <path
        id="Vector"
        d="M21 11.23C21 5.70713 16.5228 1.22998 11 1.22998C5.47715 1.22998 1 5.70713 1 11.23C1 16.7528 5.47715 21.23 11 21.23C16.5228 21.23 21 16.7528 21 11.23Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        id="Vector_2"
        d="M11.2422 16.23V11.23C11.2422 10.7586 11.2422 10.5229 11.0957 10.3764C10.9493 10.23 10.7136 10.23 10.2422 10.23"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M10.992 7.22998H11.001"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
